import { useTranslation } from 'react-i18next';
import { KoobPillGroup, KoobPill, KoobPillAdd } from '@koob/ui';

const DayPills = ({
  createDayIndex,
  deleteDayIndex,
  selectedDayIndex,
  onSelectDayIndex,
  days,
  isUnsaved,
  addDisabled = false,
  translation,
  disabled,
}) => {
  const { t } = useTranslation(translation);

  return (
    <div className="py-4">
      <KoobPillGroup>
        {(days || []).map((_, index) => (
          <KoobPill
            key={index}
            active={index === selectedDayIndex}
            data-testid={`Day ${index + 1}`}
            onClick={() => onSelectDayIndex(index)}
            onRemove={() => {
              if (selectedDayIndex >= index && selectedDayIndex > 0) {
                onSelectDayIndex(selectedDayIndex - 1);
              }
              deleteDayIndex(index);
            }}
          >
            {`${t('form.day')} ${index + 1}`}
          </KoobPill>
        ))}
        {!disabled && (
          <KoobPillAdd
            disabled={addDisabled}
            disabledTip={t('selectEnglish')}
            onClick={() => !isUnsaved && !addDisabled && createDayIndex()}
          >
            {t('misc:add')}
          </KoobPillAdd>
        )}
      </KoobPillGroup>
    </div>
  );
};

export default DayPills;
